<template>
  <div>
    <h5 class="modal-title text semi-bold">¿Cómo se calcula la espera del repartidor?</h5>
    <div class="mt-4 mb-2 px-4">
      <p class="text semi-bold dealer-wait-explanation__highlight">{{ toleranceHighlight }}</p>
      <section v-for="section in sections" :key="section.title" class="dealer-wait-explanation__section">
        <h6 class="text semi-bold dealer-wait-explanation__title">{{ section.title }}</h6>
        <p v-for="paragraph in section.paragraphs" :key="paragraph" class="dealer-wait-explanation__paragraph">{{ paragraph }}</p>
      </section>
      <section class="dealer-wait-explanation__section">
        <h6 class="text semi-bold dealer-wait-explanation__title">Preguntas frecuentes</h6>
        <div v-for="item in frequentQuestions" :key="item.question" class="dealer-wait-explanation__question">
          <p class="text semi-bold dealer-wait-explanation__paragraph">{{ item.question }}</p>
          <p class="dealer-wait-explanation__paragraph">{{ item.answer }}</p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import {
  TOLERANCE_HIGHLIGHT,
  buildDealerWaitExplanation,
  buildFrequentQuestions
} from "@/utils/dealerWaitExplanation";

export default {
  name: "DealerWaitExplanation",
  props: {
    chargeTiers: { type: Array, default: () => [] },
    changeDate: { type: String, default: null }
  },
  data: () => ({
    toleranceHighlight: TOLERANCE_HIGHLIGHT
  }),
  computed: {
    frequentQuestions() {
      return buildFrequentQuestions(this.chargeTiers);
    },
    sections() {
      return buildDealerWaitExplanation(this.chargeTiers, this.changeDate);
    }
  }
};
</script>

<style scoped>
.dealer-wait-explanation__section {
  margin-bottom: 1rem;
}
.dealer-wait-explanation__title {
  margin-bottom: 0.2rem;
  line-height: 1.3;
}
.dealer-wait-explanation__highlight {
  border-left: 4px solid currentColor;
  padding: 0.6rem 0.9rem;
  margin-bottom: 1.25rem;
}
.dealer-wait-explanation__question {
  margin-bottom: 0.75rem;
}
.dealer-wait-explanation__paragraph {
  font-size: 0.9rem;
  line-height: 1.45;
  margin-bottom: 0.4rem;
}
</style>
